import React, { Fragment, useEffect, useState } from 'react'
import { v4 as uuidv4 } from 'uuid';
import PDFPreview from './PDFPreview';
import PDFViewer from './PDFPreview';
import estilos from './CertificadosBeneficiarioComponent.module.css'
import { useDispatch, useSelector } from 'react-redux'
import { ObtenerCertificadosBeneficiario } from '../../../redux/DuckOrganismoCertificacion/OficiosBeneficiarioOCDuck';
import { actualizarDatosCertificadoFC13, actualizarDatosConstanciaFC27 } from '../../../redux/DuckOrganismoCertificacion/SolicitudesFC01_OCDuck';
import comerElegante from '../../../img/comerElegante.png'

const CertificadosBeneficiarioComponent = () => {
  const dispatch = useDispatch()

  const dataUser = useSelector(store => store.Usuario.user)
  const certificados = useSelector(store => store.OficiosBeneficiarioOC.certificados)
  console.log("certificados ", certificados)

  let rows = [
    { id: uuidv4(), fecha: '03/05/2023', tipocertificado: '27' }
  ]
  const columns = [

    { field: 'fecha', headerAlign: 'center', headerName: 'Fecha de Certificado', flex: .3 },
    { field: 'tipocertificado', headerAlign: 'center', headerName: 'Tipo de Certificado', flex: .5 },
    {
      field: 'accion', headerAlign: 'center', headerName: 'Acciones', flex: .2,
      renderCell: (params) => (
        <button onClick={() => corregirButton(params)} className='btn btn-outline-success btn-sm'>Revisar</button>
      )
    }
  ]

  useEffect(async () => {
    await dispatch(ObtenerCertificadosBeneficiario(dataUser?.[0].idlogin))
  }, [])

  const [openModal, setOpenModal] = React.useState(false);
  const [dataModal, setDataModal] = React.useState(false);

  const revisar = async (params, solicitud, formato) => {
    setOpenModal(true)
    let data = {}
    if (solicitud == '01' && formato == '13') {
      const actualizar = {
        idsolicitudesocfc13: params?.ocsolicitudfc01_fc13?.[0]?.idsolicitudesocfc13,
        idestatuspdfoc: 2
      }
      await dispatch(actualizarDatosCertificadoFC13(actualizar))
      data = await {
        tabla: 'ocsolicitudfc01_fc13_documento', idname: 'idsolicitudesocfc13',
        id: params?.ocsolicitudfc01_fc13?.[0]?.idsolicitudesocfc13,
        observaciones: params?.ocsolicitudfc01_fc13?.[0]?.observacionesbeneficiario
      }
    }
    if (solicitud == '01' && formato == '27') {
      const actualizar = {
        idsolicitudesocfc27: params?.ocsolicitudfc01_fc27?.[0]?.idsolicitudesocfc27,
        idestatuspdfoc: 2
      }
      await dispatch(actualizarDatosConstanciaFC27(actualizar))
      data = await {
        tabla: 'ocsolicitudfc01_fc27_documento', idname: 'idsolicitudesocfc27',
        id: params?.ocsolicitudfc01_fc27?.[0]?.idsolicitudesocfc27,
        observaciones: params?.ocsolicitudfc01_fc27?.[0]?.observacionesbeneficiario
      }
    }
    setDataModal(await data)
  }


  return (
    <Fragment>
      <div className='container2 row text-center'>
        <h3>CERTIFICADOS</h3>
        {certificados?.ocsolicitudfc01?.map((solicitud, key) => {
          return (
            <div className={`${estilos.blogSlider} mt-3`} key={key}>
              <div className="blog-slider__wrp swiper-wrapper">
                <div className={`${estilos.blogSlider__item} ${estilos.swiperSlide}`}>
                  <div className={`${estilos.blogSlider__img}`}>
                    <img className={`${estilos.img}`} src={comerElegante} alt="" />
                  </div>
                  <div>
                    <span className={`${estilos.blogSlider__code}`}>{solicitud?.fechaatendida?.substring(0, 10)}</span>
                    <div className={`${estilos.blogSlider__title}`}>Solicitud de inscripción</div>
                    <div className={`${estilos.blogSlider__text}`}></div>
                    {solicitud?.ocsolicitudfc01_fc13?.length > 0 &&
                      (solicitud?.ocsolicitudfc01_fc13?.[0]?.idestatuspdfoc == 1 || solicitud?.ocsolicitudfc01_fc13?.[0]?.idestatuspdfoc == 2) &&
                      <a href="#" className={`${estilos.blogSlider__button}`} onClick={() => revisar(solicitud, '01', '13')}>Certificado Instalaciones</a>
                    }
                    {solicitud?.ocsolicitudfc01_fc27?.length > 0 &&
                      (solicitud?.ocsolicitudfc01_fc27?.[0]?.idestatuspdfoc == 1 || solicitud?.ocsolicitudfc01_fc27?.[0]?.idestatuspdfoc == 2) &&
                      <a href="#" className={`${estilos.blogSlider__button} mt-3`} onClick={() => revisar(solicitud, '01', '27')}>Certificado Comercializador</a>
                    }
                  </div>
                </div>
              </div>
            </div>
          )
        })}



        {openModal && <PDFViewer setOpenModal={setOpenModal} data={dataModal} />}
        {/*<div style={{ height: 600, width: '95%', color: 'black' }}>
          <DataGrid
            rows={(rows)}
            columns={(columns)}
            pageSize={10}
            rowsPerPageOptions={[0]}

            //initialState={{ sorting: { sortModel: [{ field: 'fecha', sort: 'desc' }], }, }}

            sx={{
              boxShadow: 0,
              color: 'black',
              border: 0,
              '& .MuiDataGrid-cell': {
                display: 'block',
                position: 'relative',
                textAlign: 'center',
              },
              '& .MuiDataGrid-columnHeaders': {
                backgroundColor: '#c88b3e',
                color: 'white',
                fontFamily: 'Montserrat',
                fontWeight: 'bold',
                height: '20px'
              }
            }}
          />
        </div>*/}
      </div>
    </Fragment>
  )
}

export default CertificadosBeneficiarioComponent